import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import BasicDropdownToggle from '../BasicDropdownToggle';
import { PopperDropdownContext } from './PopperDropdownContext';
var PopperDropdownToggle = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var setToggleRef = useContext(PopperDropdownContext).setToggleRef;
    return (React.createElement(BasicDropdownToggle, __assign({}, props, { innerRef: setToggleRef }), children));
};
PopperDropdownToggle.displayName = 'PopperDropdownToggle';
export default PopperDropdownToggle;
//# sourceMappingURL=PopperDropdownToggle.js.map